import React from "react"
import { Mail } from "lucide-react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

export default function Footer() {
    const { t } = useTranslation()

    return (
        <footer className="bg-slate-950 text-slate-400 py-20 border-t border-white/5">
            <div className="container mx-auto px-4 md:px-6">
                <div className="grid md:grid-cols-4 gap-12 mb-16">
                    <div className="col-span-1 md:col-span-2">
                        <div className="mb-6">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="w-10 h-10 rounded-xl bg-emerald-600 flex items-center justify-center text-slate-950 font-bold text-2xl shadow-[0_0_20px_rgba(16,185,129,0.3)]">
                                    B
                                </div>
                                <span className="text-2xl font-bold text-white tracking-tight">
                                    Bousanm TECHNOLOGY
                                </span>
                            </div>
                            <p className="text-emerald-500 font-bold tracking-widest text-xs uppercase mb-4">
                                {t('footer.subtitle')}
                            </p>
                        </div>
                        <p className="max-w-md text-slate-400 leading-relaxed mb-6">
                            {t('footer.description')}
                        </p>
                        <p className="max-w-md text-xs text-slate-500 leading-relaxed italic">
                            {t('footer.disclaimer')}
                        </p>
                    </div>

                    <div>
                        <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">{t('footer.platform')}</h4>
                        <ul className="space-y-4 text-sm">
                            <li><a href="#what-we-do" className="hover:text-emerald-500 transition-colors">{t('nav.whatWeDo')}</a></li>
                            <li><a href="#product-overview" className="hover:text-emerald-500 transition-colors">{t('nav.overview')}</a></li>
                            <li><a href="#who-we-serve" className="hover:text-emerald-500 transition-colors">{t('nav.whoWeServe')}</a></li>
                            <li><a href="#compliance" className="hover:text-emerald-500 transition-colors">{t('nav.compliance')}</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">{t('footer.legal')}</h4>
                        <ul className="space-y-4 text-sm">
                            <li>
                                <Link to="/privacy-policy" className="hover:text-emerald-500 transition-colors">
                                    {t('footer.privacyPolicy')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/terms-of-use" className="hover:text-emerald-500 transition-colors">
                                    {t('footer.termsOfService')}
                                </Link>
                            </li>
                            <li className="pt-4 border-t border-white/5 space-y-4">
                                <a href="mailto:support@bousanmtechnology.com" className="hover:text-emerald-500 transition-colors flex items-center gap-3">
                                    <div className="p-2 bg-emerald-500/10 rounded-lg">
                                        <Mail className="w-4 h-4 text-emerald-500" />
                                    </div>
                                    <span className="font-medium text-slate-300">support@bousanmtechnology.com</span>
                                </a>
                                <div className="text-xs text-slate-500 leading-relaxed pl-12 bg-slate-900/50 p-3 rounded-lg border border-white/5">
                                    {t('footer.address')}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500">
                    <p>{t('footer.copyright')}</p>
                </div>
            </div>
        </footer>
    )
}
